<template>
  <div class="page-block">
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">特定商取引法に基づく表記</h3>
    </div>
    <div class="page-block__inner pcmb20">
      <div class="company-area pcmb20 spmb20">
        <table class="company-area__table">
          <tr>
            <th>サービスサイト名</th>
            <td class="pcpb10">
              narasu<br>
              (サブスクリプション型音楽配信代行サービス)
            </td>
          </tr>
          <tr>
            <th>運営事業者の名称</th>
            <td>株式会社ローディアム</td>
          </tr>
          <tr>
            <th>代表者</th>
            <td>
              松坂 祐弥
            </td>
          </tr>
          <tr>
            <th>所在地</th>
            <td>
              〒150-0043 東京都渋谷区道玄坂1-2-3 渋谷フクラス17F
            </td>
          </tr>
          <tr>
            <th>電話番号</th>
            <td>
              03-6770-8606<br><br>
              ※お電話でのお問い合わせは受付しておりません。<br>
              お問い合わせにつきましては<router-link
                class="c-text-link"
                target="_blank"
                :to="{name: 'contact'}">
                お問い合わせフォーム
              </router-link>よりお願いいたします。
            </td>
          </tr>
          <tr>
            <th>お問い合わせ先</th>
            <td>
              contact@narasu.jp
            </td>
          </tr>
          <tr>
            <th>サービス利用料</th>
            <td class="pcpb10">
              1) サブスクプラン<br>
              月額：110円(税込)<br><br>
              2) 1回払いきりプラン<br>
              シングル 2,860円(税込)<br>
              アルバム 5,500円(税込)<br><br>
              ※値段は変更されることがありますのでご了承ください。
            </td>
          </tr>
          <tr>
            <th>
              サービス価格以外の必要料金
            </th>
            <td class="pcpb10">
              <ul>
                <li>
                  金融機関への振込手数料：330円（税込）
                </li>
                <li>
                  サービスにアクセスする際に発生する通信料、プロバイダ料金、その他インターネットの利用のために必要となる費用
                </li>
                <li>
                  キャリア決済手数料
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>
              お支払い方法
            </th>
            <td class="pcpb10">
              <ul>
                <li>
                  クレジットカード（VISA・Mastercard・JCB・American Express・Diners Club）
                </li>
                <li>
                  キャリア決済（auかんたん決済・d払い・ソフトバンクまとめて支払い）
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>
              代金支払時期
            </th>
            <td class="pcpb10">
              1. サブスクプラン<br>
              クレジットカード、auかんたん決済、d払い、ソフトバンクまとめて支払い：初回の当月分は楽曲登録時、2ヶ月目以降は毎月1日に自動課金<br>
              2. 1回払いきりプラン<br>
              クレジットカード、auかんたん決済、d払い、ソフトバンクまとめて支払い：楽曲登録時 <br><br>
              ※お客様の口座からの引き落とし等がされるのは、契約した各クレジットカード会社または各キャリアの指定する引き落とし日となります。
            </td>
          </tr>
          <tr>
            <th>
              役務提供開始時期
            </th>
            <td>
              楽曲登録時のオンライン決済終了後からサービス提供開始となります。
            </td>
          </tr>
          <tr>
            <th>
              サブスクプランの解約について
            </th>
            <td class="pcpb10">
              アカウント情報画面から、ご契約プランの「解約する」よりお手続きお願いします。<br>
              サブスクプランを解約する場合は、下記にご同意頂く必要がございます。<br>
              ・サブスクプランのご契約期間が1年間未満の場合、解約料として1,320円(税込)を解約手続き時にお支払いいただきます。<br>
              ・サブスクプランのご契約期間中に登録済みの楽曲は、全配信ストアで全て配信停止となります。<br>
              ・1回払いきりプランで再登録する場合は、再度楽曲登録が必要となります。<br>
            </td>
          </tr>
          <tr>
            <th>
              動作環境
            </th>
            <td class="pcpb10">
              Google Chrome 最新版<br>
              Mozilla FireFox 最新版<br>
              Microsoft Edge 最新版<br>
              Safari 最新版 <br><br>
              また、JavaScript、Cookieは有効に設定してください。
            </td>
          </tr>
        </table>
      </div>
      <p>本特定商取引法に基づく表記は2020年12月1日より実施します。</p>
    </div>
    <div class="c-btn-wrap c-btn-wrap-faq">
      <router-link
        :to="{ name: 'index' }"
        class="c-btn c-btn--back">
        トップへ戻る
        <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Scta',
}
</script>

<style scoped>
  ul > li{
    list-style: disc;
    margin-left: 1.0em;
    padding: .5em .5em .5em 0;
  }
</style>
